/**
 * Public static object: Const
 * ---------------------------
 * Constants shared throughout the Karel program.
 */

export const Const = {
  WORLD_FILL: 0.8,
  KAREL_NORTH: 0,
  KAREL_EAST: 1,
  KAREL_SOUTH: 2,
  KAREL_WEST: 3,

  KAREL_SMALL_SIZE: 30,

  BORDER_SIZE: 2,
  CROSS_FRACTION: 0.25,
  CROSS_THICKNESS_FRACTION: 0.32,
  MIN_CROSS_SIZE: 5,

  BEEPER_SIZE_FRACTION: 0.85,
  BEEPER_FILL_COLOR: "#12C4FF",
  BEEPER_LABEL_FRACTION: 0.3,
  BEEPER_LABEL_MIN_SIZE: 6,
  BEEPER_LABEL_MAX_SIZE: 18,
  BEEPER_LABEL_FONT: "sans-serif",
  BEEPER_LABEL_DY: 0.2,
  WALL_THICKNESS_FRACTION: 0.1,
  BACKGROUND_COLOR: "white",

  // Canvas colors historically hard-coded in KarelView. Kept mutable so the
  // Theme manager can override them from CSS custom properties.
  CANVAS_GRID_COLOR: "#3b82f6",
  CANVAS_WALL_COLOR: "#000000",
  CANVAS_TEXT_COLOR: "#000000",

  // Colors for the Karel sprite outline/feet and body. The source SVGs are
  // recolored at load time from these values so the robot stays legible on a
  // dark playfield.
  CANVAS_KAREL_STROKE: "#000000",
  CANVAS_KAREL_FILL: "#ffffff",
};

export type ConstType = typeof Const;
